const moodboard = { moodboard_name: 'Scandinavian 2022', moodboard_uuid: '123' };
export const mockMoodboards = Array(5)
  .fill(undefined)
  .map((item) => ({ ...moodboard, moodboard_uuid: String(Math.random()) }));
